import React, { Component } from 'react';

class SmallLoader extends Component {
  render(){

    return(
      <div className="small-loader">
        <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}
export default SmallLoader;


// WEBPACK FOOTER //
// ./src/modules/pieces/SmallLoader.js